import classnames from "classnames";
import {ReactNode} from "react";
import {FiArrowDown, FiArrowUp} from "react-icons/fi";
import {IoFilter} from "react-icons/io5";

import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {IncidentSortBy} from "@/lib/types/statuspages.ts";

import css from "./IncidentsSortMenu.module.scss";

export interface IncidentsSortMenuProps {
  setSortBy: (sortBy: IncidentSortBy) => void;
  sortBy?: IncidentSortBy;
}

const SortMenuItem = ({
  sortBy,
  setSortBy,
  text,
  subText,
  selected,
}: {
  sortBy: IncidentSortBy;
  setSortBy: (sortBy: IncidentSortBy) => void;
  text: string;
  subText?: ReactNode;
  selected: boolean;
}) => {
  return (
    <DropdownItem
      onClick={() => {
        setSortBy(sortBy);
      }}
      className={"pe-3"}
    >
      <div className="w-100 d-flex justify-content-between gap-5 align-items-center">
        <div className={classnames({pulseTextBodySmallBold: selected})}>{text}</div>
        <span className="pulse-color-blue-500">{subText}</span>
      </div>
    </DropdownItem>
  );
};

export const IncidentsSortMenu = ({setSortBy, sortBy}: IncidentsSortMenuProps) => {
  return (
    <DropdownButton className={css.IncidentsSortMenu} title={"Sort By"} variant={"secondary"} icon={IoFilter}>
      <SortMenuItem
        sortBy={IncidentSortBy.MOST_RECENTLY_UPDATED}
        setSortBy={setSortBy}
        selected={sortBy === IncidentSortBy.MOST_RECENTLY_UPDATED}
        text="Most Recently Updated"
        subText={
          <>
            Descending <FiArrowDown />
          </>
        }
      />
      <SortMenuItem
        sortBy={IncidentSortBy.MOST_RECENTLY_CREATED}
        setSortBy={setSortBy}
        selected={sortBy === IncidentSortBy.MOST_RECENTLY_CREATED}
        text="Most Recently Created"
        subText={
          <>
            Descending <FiArrowDown />
          </>
        }
      />
      <SortMenuItem
        sortBy={IncidentSortBy.UPCOMING_FIRST}
        setSortBy={setSortBy}
        selected={sortBy === IncidentSortBy.UPCOMING_FIRST}
        text="Upcoming First"
        subText={
          <>
            Ascending <FiArrowUp />
          </>
        }
      />
      <SortMenuItem
        sortBy={IncidentSortBy.UPCOMING_LAST}
        setSortBy={setSortBy}
        selected={sortBy === IncidentSortBy.UPCOMING_LAST}
        text="Upcoming Last"
        subText={
          <>
            Descending <FiArrowDown />
          </>
        }
      />
    </DropdownButton>
  );
};
